var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
export default Vue.extend({
    name: 'searchSelectAddModel',
    data: function () {
        return {
            searchSelectData: [],
        };
    },
    props: {
        formData: {
            type: Object,
            require: true,
        },
        current: {
            type: String,
            require: true,
        },
        size: {
            type: String,
            default: '',
        },
        requestConfig: {
            type: Object,
            default: function () {
                return {
                    url: '',
                    method: '',
                    params: {},
                };
            },
        },
        selectConfig: {
            type: Object,
            default: function () {
                return {
                    labelName: 'val',
                    valName: 'val',
                };
            },
        },
    },
    computed: {
        isHasOptions: function () {
            return this.searchSelectData instanceof Array &&
                this.searchSelectData.length > 0
                ? true
                : false;
        },
    },
    created: function () {
        this.getList();
    },
    methods: {
        getFilterList: function (key) {
            this.getList(key);
        },
        getList: function (key) {
            var _this = this;
            if (key === void 0) { key = ''; }
            var _a = this.requestConfig, url = _a.url, method = _a.method, params = _a.params;
            if (!url)
                return this.$message.error('请配置请求地址');
            this.$request({
                url: url,
                method: method || 'post',
                data: __assign({}, params, { key: key }),
            }).then(function (res) {
                _this.searchSelectData = [];
                if (!res || res.errorCode)
                    return;
                var data = res.data;
                data.forEach(function (val, index) {
                    _this.searchSelectData.push({
                        val: val,
                    });
                });
                if (!_this.isHasOptions) {
                    _this.searchSelectData = [
                        {
                            val: '无匹配数据',
                            disabled: true,
                        },
                    ];
                }
            });
        },
    },
});
